import { Card, Stack, Text, TextInput } from '@mantine/core';
import { useClientFormContext } from '../ClientPersonalSection';

export const ContactCard = (): JSX.Element => {
  const form = useClientFormContext();

  return (
    <Card padding="md" radius="md" withBorder>
      <Text fw={700} size="large">
        Kontaktní údaje
      </Text>
      <Stack gap="sm" className="mt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="Telefon"
          {...form.getInputProps(`phone`)}
        />
        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="E-mail"
          {...form.getInputProps(`email`)}
        />
      </Stack>
    </Card>
  );
};
